import { render } from "./OptionsText.vue?vue&type=template&id=1fefc86f"
import script from "./OptionsText.vue?vue&type=script&lang=js"
export * from "./OptionsText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__